import { useParams } from 'src/routes/hooks';

import { useAppSelector } from 'src/hooks';

import { ExpenseEditForm } from './expense-new-edit-form';

// ----------------------------------------------------------------------

const metadata = { title: `Ordre` };

export default function ExpenseEditView() {
  const { id = '' } = useParams();

  const expenses = useAppSelector((state) => state.expenses.expenses);
  const expense = expenses.find((_expense) => _expense.id === id);

  return (
    <>
      <title>{metadata.title}</title>
      {expense && <ExpenseEditForm currentExpense={expense} />}
    </>
  );
}
